import { render, staticRenderFns } from "./TaskComponentsParser.vue?vue&type=template&id=206ba9a6&"
import script from "./TaskComponentsParser.vue?vue&type=script&lang=js&"
export * from "./TaskComponentsParser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports